import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(({ colors, zIndexLevels }) => ({
    dropdown: {
        display: 'flex',
        backgroundColor: colors.white,
        position: 'absolute',
        zIndex: zIndexLevels.one,
        padding: '10px',
        borderRadius: '4px',
        left: '0',
        transform: 'translateX(-50%)',
        boxShadow:
            '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
        '& > *': {
            padding: '10px',
            color: colors.orange,
            '&:hover': {
                color: colors.orange,
            },
        },
    },
    anchor: {
        position: 'relative',
        left: '50%',
    },
}))
